<template>
    <div class="TP--container">
        <div class="TP">
            <div class="TP--comment" v-if="step && customerReviews && customerReviews.registrationSteps">
                <p class="TP--comment--text">{{ getCommentText }}</p>
                <p class="TP--comment--foot">{{ `-${getCommentAuthor}, ${getCommentDate}`}}</p>
            </div>
            <div class="TP--widget">
                <div v-if="trustPilotId" ref="trustBoxRef" class="trustpilot-widget" :data-locale="TPLocale" data-template-id="5419b6ffb0d04a076446a9af" :data-businessunit-id="trustPilotId" data-style-height="50px" data-style-width="100%" data-theme="light">
                    <a href="" target="_blank" rel="noopener"></a>
                </div>
                <div v-if="trustedBadgeId">
                    <div id="MyCustomTrustbadge" class="trustbadge"></div>
                    <div id="MyMobileCustomTrustbadge" class="mobile-trustbadge"></div>
                </div>
            </div>
        </div>
       <div class="TP--background-container">
            <img class="TP--background-image--desktop" src="https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/homepage/PAPER-BACKGROUND-DESKTOP.png" alt="Paper background" />
            <img class="TP--background-image--mobile" src="https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/homepage/PAPER-BACKGROUND-MOBILE.png" alt="Paper background"  />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import countries from '@/resources/countries.json';

export default {
    name: 'TrustPilotReview',
    props: {
        step: {
            type: String,
            require: false,
            default: null,
        },
    },
    data() {
        return {
            customerReviews: null,
        };
    },
    mounted() {
        this.loadBadge();
        this.getReviews();
    },
    computed: {
        ...mapGetters({
            TPScriptStatus: 'cookies/getTrustpilotMounted',
        }),
        trustPilotId() {
            return process.env.VUE_APP_TRUST_PILOT_KEY || null;
        },
        trustedBadgeId() {
            return process.env.VUE_APP_TRUSTED_SHOPS_KEY || null;
        },
        TPLocale() {
            return `${this.selectedLocale}-${this.countryIso2.toUpperCase()}`;
        },
        countryIso2() {
            const country = countries.filter(item => item.iso.toUpperCase() === process.env.VUE_APP_COUNTRY_ISO.toUpperCase());
            return country[0].iso2;
        },
        selectedLocale() {
            return this.$root.$i18n.locale.split('-')[1];
        },
        getCommentText() {
            return this.customerReviews ? this.customerReviews.registrationSteps[this.step].review : '';
        },
        getCommentDate() {
            return this.customerReviews ? this.customerReviews.registrationSteps[this.step].date : '';
        },
        getCommentAuthor() {
            return this.customerReviews ? this.customerReviews.registrationSteps[this.step].name : '';
        },
    },
    methods: {
        async getReviews() {
            const reviews = await require(`@/content/${process.env.VUE_APP_COUNTRY_ISO}/${process.env.VUE_APP_I18N_LOCALE}/customerTrustPilotReviews.json`);
            this.customerReviews = reviews;
        },
        loadBadge() {
            if (this.TPScriptStatus && this.trustPilotId) window.Trustpilot.loadFromElement(this.$refs.trustBoxRef, true);
            if (!this.TPScriptStatus && this.trustPilotId) this.$store.dispatch('cookies/mountTrustPilot');

            const TBScript = document.querySelectorAll(`[src="//widgets.trustedshops.com/js/${process.env.VUE_APP_TRUSTED_SHOPS_KEY}.js"]`)[0];
            if (this.trustedBadgeId && TBScript) {
                TBScript.parentNode.removeChild(TBScript);
                this.$store.commit('cookies/setTrustedShops', false);
            }
            if (this.trustedBadgeId) this.$store.dispatch('cookies/mountTrustedShops');
        },
    },
    watch: {
        selectedLocale(newValue) {
            this.getReviews();
        },
    },
};
</script>

<style lang="scss" scoped>
$trustbadge-mobile-bp: 640px;

.trustbadge {
    height: 80px;
    width: 100%;
    justify-content: center;
    display: none;
    @media(min-width: $trustbadge-mobile-bp) {
        display: flex;
    }
}
.mobile-trustbadge {
    height: 80px;
    width: 100%;
    display: flex;
    justify-content: center;
    @media(min-width: $trustbadge-mobile-bp) {
        display: none;
    }
}

.TP--container{
    position: relative;
    text-align: center;
}

.TP {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 0;
    width: 80%;
    margin: 0 10%;
    height: 100%;
    &--comment {
        margin: 1rem;
        &--text {
            text-align: center;
        }
        &--foot {
            text-align: center;
            font-family: 'FreddiesFlowersTitle';
        }
    }
    &--widget {
        margin: 1rem;
    }

    &--background-image {
        &--desktop {
            display: none;
        }
        &--mobile {
            max-width: unset;
            width: 100%;
            height: 400px;
        }
    }

    &--background-container {
        display: block;
        width: 100%;
    }
}

@media (min-width: 768px) {
   .TP {
        width: 60%;
        margin: 0 20%;
        &--background-image {
            &--desktop {
                display: block;
                width: max-content;
                max-width: unset;
                height: 400px;
            }
            &--mobile {
                display: none;
            }
        }
   }
}

@media (min-width: 1024px) {
   .TP {
        width: 50%;
        margin: 0 25%;
    }
}

@media (min-width: 1380px) {
    .TP--background-image--desktop {
        width: 100%;
        height: auto;
    }
}
</style>
